<template>
    <div class="insurance-page">
            <!-- <scroll-view :scroll-into-view="currentPosition" class="scroll-view-insurance" scroll-y="true" :scroll-with-animation="true"  > -->
                <div class="big-photo">
                    <img src="https://src.imenushop.com/uploads/big-photo2.jpg" alt="" mode="widthFix" />
                </div>
                <div class="container">
                    <div class="box">
                        <div class="bg">
                            <div class="tabbar">
                                <!-- <div class="tab-item" >
                                    <img src="@/static/img/insurance/logo.png" alt=""  />
                                </div>
                                <div class="tab-item tab-line" ></div> -->
                                <div class="tab-item" @click="scrollHandle(1)">Aon医疗保险 </div>
                                <div class="tab-item tab-line" ></div>
                                <div class="tab-item" @click="scrollHandle(2)">为什么选择Aon </div>
                                <div class="tab-item tab-line" ></div>
                                <div class="tab-item" @click="scrollHandle(3)">保险内容</div>
                               
                            </div>
                            <div class="tabbar tabbar1">
                               
                            </div>
                            <div class="bg-left"></div>
                            <div class="bg-right"></div>
                        </div>
                        
                        <div class="tab-1" >
                            <div class="title" id="tab-title-1">
                                <div class="title-mask">
                                    Aon国民基本医疗保险
                                </div>
                            </div>
                            <div class="content">Aon国民基本医疗保险，专为在荷居民提供全面高性价比的医疗健康保险。我们以优惠的价格，提供最贴心的产品和服务。同时，我们还为在荷华人提供中文引导服务，帮助您更好的选择合适自己的保险项目。</div>
                            <div class="icon-list">
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/3.png" alt="">
                                    <div>全荷性价比</div>
                                    <div>最高保险</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/2.png" alt="">
                                    <div>中荷双语</div>
                                    <div>保险明细</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/1.png" alt="">
                                    <div>赠送牙科</div>
                                    <div>意外保险</div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line-left"></div>
                                <div class="line-content">
                                    -----------------------------------------------------------------
                                    -----------------------------------------------------------------
                                    -----------------------------------------------------------------
                                </div>
                                <div class="line-right"></div>

                                <!-- <img src="@/static/img/insurance/line.png" alt="" mode="widthFix"> -->
                            </div>
                            <!-- 适用人群 -->
                            <div class="shiyong">
                                <div class="shiyong-title">适用人群:</div>
                                <div class="shiyong-content">所有在荷兰的居民（包含荷兰公民和持有荷兰居留证的居民）均可以购买Aon基本医疗保险。</div>
                                <img src="https://src.imenushop.com/uploads/shiyongrenqun.jpg" alt="" mode="widthFix" />
                            </div>
                        </div>
                        <div class="tab-2">
                            <div class="title" id="tab-title-2">
                                <div class="title-mask">
                                    在荷兰购买医疗保险的必要性
                                </div>
                            </div>
                            <div class="content">根据荷兰医疗保险法（Zorgverzekeringswet）规定，每个荷兰公民、在荷兰居住、以及在荷兰工作并有收入的人都必须投保医疗保险。Aon基本医疗保险，为您提供性价比最高、最贴心的医疗保险服务。</div>
                            <div class="title-two">Aon医疗保险涵盖您需要的所有</div>
                            <div class="content-two">
                                <div class="content-two-content">
                                    Aon基本医疗保险会为您提供日常生活中所需的大多数医疗服务，如普通/专科医生门诊、医疗器械费用、急诊、怀孕生产以及18周岁以下未成年人的全面牙科医疗。除基本医疗保险服务外，Aon还提供各类补充保险服务，涵盖您需要的所有医疗服务。
                                </div>
                                <div class="content-two-list">
                                    <div class="contnet-two-item" v-for="(item,index) in tabTwoList" :key="index">
                                        <img src="@/static/img/insurance/correct.png" alt="">
                                        <div>{{item}}</div>
                                    </div>
                                </div>

                            </div>
                            <img class="icon-list-photo" src="@/static/img/insurance/8.jpg" alt="">
                            <!-- <div class="icon-list">
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/3.png" alt="">
                                    <div class="icon-title">全荷性价比最高</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/4.png" alt="">
                                    <div class="icon-title">签约医院/机构</div>
                                    <div class="icon-title">全报销</div>
                                    <div>无需奔波,就近就医</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/5.png" alt="">
                                    <div class="icon-title">旅游紧急救助全报销</div>
                                    <div class="icon-title">全报销</div>
                                    <div>安心出行,健康随行</div>
                                </div>

                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/3.png" alt="">
                                    <div class="icon-title">贴心中文解读</div>
                                    <div>高性价比,全面保障</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/4.png" alt="">
                                    <div class="icon-title">中荷双语保险规则</div>
                                    <div>全荷独家,更易选择</div>
                                </div>
                                <div class="icon-item">
                                    <img class="icon" src="@/static/img/insurance/5.png" alt="">
                                    <div class="icon-title">线上报销,高校方便</div>
                                    <div>流程简单,一键搞定</div>
                                </div>
                            </div> -->
                        </div>
                        <div class="tab-3">
                            <div class="title" id="tab-title-3">
                                <div class="title-mask">
                                    Aon基本医疗保险3款套餐
                                </div>
                            </div>
                                <div class="componet-level" v-for="item in levelList" :key="item.id">
                                    <level :data="item" :key="item.id" />   
                                </div>
                        </div>
                        <div class="tab-4">
                                <div class="title">
                                    <div class="title-mask">
                                        补充保险简介
                                    </div>
                                </div>
                                <div class="content">除了以上套餐外,Aon医疗健康保险还有广泛的补充保险项目。目前有5个补充保险套餐可供您选择:基础Vitaal、Vitaal 1+、2+、3+、premium+</div>
                                <div class="content">其中基础Vitaal是入门级的套餐，如果您没有太多的医疗需求,这款套餐会很适合您;Vitaal 4+会提供最全面的保险项目。</div>
                                <div class="title-two">基础Vitaal包含以下保险项目:</div>
                                <div class="content-two">
                                
                                    <div class="content-two-list">
                                        <div class="contnet-two-item" v-for="(item,index) in vitaalList1" :key="index">
                                            <img src="@/static/img/insurance/correct.png" alt="">
                                            <div>{{item}}</div>
                                        </div>
                                    </div>

                                </div>
                        
                        </div>
                        <div class="tab-5">
                            <div class="title">
                                <div class="title-mask">
                                    Vitaal补充保险项目包含
                                </div>
                            </div>
                            <div class="title-two">
                                    （不同等级1+、2+、3+、Premium+）
                            </div>
                            <div class="icon-list">
                                <div class="icon-item" v-for="(item,index) in vitaalList2" :key="index">
                                    <!-- <img class="icon" src="@/static/img/insurance/3.png" alt=""> -->
                                        <div class="icon">{{index + 1}}</div>
                                        <div>{{item}}</div>
                                </div>
                            </div>
                            <div class="line">
                                <div class="line-left"></div>
                                <div class="line-content">
                                    -----------------------------------------------------------------
                                    -----------------------------------------------------------------
                                    -----------------------------------------------------------------
                                </div>
                                <div class="line-right"></div>

                                <!-- <img src="@/static/img/insurance/line.png" alt="" mode="widthFix"> -->
                            </div>
                            <!-- 适用人群 -->
                            <div class="shiyong">
                                <div class="shiyong-content">*注意:补充保险的承包范围每年都会略有变化,Aon会定期调整保险项目和报销额度，以便更好的满足您的医疗健康需求。我们会及时通知您补充保险项目的变化，以便您为新一年的投保做出更好的选择。</div>
                            </div>
                        </div>
                        <div class="tab-6">
                                <div class="title">
                                    <div class="title-mask">
                                        补充保险简介
                                    </div>
                                </div>
                                <div class="content">在荷兰，成年人的牙科保险均不在国民基本医疗保险范围内。因此，如您有需求，可以选择额外购买牙科保险。额外购买的Aon牙科保险涵盖您在牙医和口腔医生处产生的费用。</div>
                                <div class="title-two">在Aon医疗健康保险中，有4种牙科保险套餐。</div>
                                <div class="title-two">您可以从中按需进行选择:</div>
                                <div class="content-two">
                                
                                    <div class="content-two-list">
                                        <div class="contnet-two-item" v-for="(item,index) in vitaalList3" :key="index">
                                            <div class="level-tag">等级&nbsp;{{index}}：</div>
                                            <div>{{item}}</div>
                                        </div>
                                    </div>

                                </div>
                                <div class="content">此外，Aon将于2022年赠送所有投保人一份牙科意外保险，为您的牙齿健康保驾护航。最高保费高达€22,500。</div>

                        
                        </div>
                        <div class="tab-7">
                                <div class="title">
                                    <div class="title-mask">
                                        全部保险项目（中荷双语）
                                    </div>
                                </div>
                                <!-- @/static/AON.xlsx -->
                                <a href="./Aon中荷双语保险细则.xlsx" rel="external"  download="点击查看附件:Aon中荷双语保险细则.xlsx" >点击查看附件:Aon中荷双语保险细则.xlsx</a>
                                <!-- <a href="">点击查看附件:Aon中荷双语保险细则.xlsx</a> -->
                        </div>
                        <div class="tab-8">
                                <div class="title">
                                    <div class="title-mask">
                                        选择保险
                                    </div>
                                </div>
                                <img src="@/static/img/insurance/qr.png" alt="">
                                <span>扫码上方二维码，开始选择您的保险;</span>
                                <!-- @/static/AON.xlsx -->
                                <div class="web"><span>网址：</span><a href="https://iak.nl/landingspagina/welcome-to-aon-chinese"  >https://iak.nl/landingspagina/welcome-to-aon-chinese</a></div>
                                <!-- <a href="">点击查看附件:Aon中荷双语保险细则.xlsx</a> -->
                        </div>
                        <div class="bottom-container">
                            <div class="cn">关于Aon国民医疗健康保险的所有中文内容均基于官方的英文材料翻译而成。若中文版本与原始英文版本不一致，请以原始英文版本为准。</div>
                            <div class="en">All the content for the Aon Chinese Arrangement has beenprepared in English. In the event of inconsistency between the original English version and any translation,the English version will always prevail.</div>

                        </div>
                        <div style="text-align: center;margin-top: 30px">© {{year}} 荷兰生活网 All Rights Reserved</div>
                    </div>
                </div>
            <!-- </scroll-view> -->
            

    </div>
</template>

<script>
import level from "./components/level.vue"
export default {
    name: 'Aon',
    components: {
        level
    },
    data() {
        return {
            year: 2021,
            currentPosition: '',
            scrollList:[],
            tabTwoList:[
                '普通专科医生门诊',
                '医疗器械',
                '急诊',
                '怀孕生育',
                '18周岁以下未成年保险',
                '牙医意外险',
                '物理治疗后的护理',
                '各类补充保险',
            ],
            vitaalList1:[
                '国外紧急医疗',
                '牙齿意外事故牙科护理',
                '因医疗需求紧急遣返',
                '医生二次诊疗意见',
            ],
             vitaalList2:[
                '理疗',
                '药品',
                '眼镜和隐形眼镜',
                '疾病预防',
                '补充和代替医疗、特殊护理',
                '牙齿保健',
                '心理咨询',
                '跨境医疗',
                '医疗器械',
                '更多项目...',
            ],
            vitaalList3:[
                '最高保额250欧元',
                '最高保额500欧元',
                '最高保额1,000欧元',
                '最高保额1,500欧元',
            ],
            levelList:[
                {
                    title:'基础医疗套餐',
                    tags:[
                        '全荷同类服务最低价格；',
                        '在签约医院和医疗机构就诊，100%报销;',
                        '如需急诊救助，在荷兰任意一家医院就诊，均可100%报销;',
                        '在非签约医疗机构就诊，可报销总费用的75%。'
                    ],
                    price:117.28,
                    id:1
                },
                {
                    title:'升级医疗套餐',
                    tags:[
                        '超高性价比;',
                        '更多签约医院/医疗机构选择;',
                        '在签约医院和医疗机构就诊，100%报销;',
                        '如需急诊救助,在荷兰任意一家医院就诊，均可100%报销;',
                        '在非签约医疗机构就诊，可报销总费用的75%。'
                    ],
                    price:124.88,
                    id:2
                },
                {
                    title:'高级医疗套餐',
                    tags:[
                        '超高性价比;',
                        '任意选择医院/医疗结构就诊;',
                        '在签约医院和医疗机构就诊，100%报销;',
                        '专属家庭医生;',
                        '如需急诊救助，在荷兰任意一家医院就诊，均可100%报销;',
                        '在非签约医疗机构就诊，可报销总费用的75%。'
                    ],
                    price:136.75,
                    id:3
                },
            ]
        }
    },
    onLoad() {
        this.year = new Date().getFullYear()
    },
    methods: {
        scrollHandle(index) {
            const ID = 'tab-title-' + index;
            this.currentPosition = ID
       
            document.getElementById(ID).scrollIntoView({behavior:'smooth'});

        }
    }
}
</script>

<style scoped lang="less">
.uni-page-head {
    display: none;
}
.insurance-page {
  background: #e5e5e5;
  margin: 0 auto;
    max-width: 750px;
    .scroll-view-insurance {
        height:100vh;
    }
    .big-photo {
        img {
            width: 100%;
            overflow: hidden;
            vertical-align: middle;
            min-height: 125px;
        }
    }
    .container {
        position: relative;
        padding-top: 25px;
        box-sizing: border-box;
        background-color:#e5e5e5;
        .box {
            // height: 300px;
            padding-bottom: 30px;
            .bg {
                position: absolute;
                top: 0;
                left: 0;
                background-color: #e01b22;
                width: 100%;
                height: 300px;
                .bg-left {
                    position: absolute;
                    left: 0;
                    bottom: 0;
                    border: 5px solid transparent;
                    border-left-color: #e5e5e5;
                    border-bottom-color: #e5e5e5;
                }
                .bg-right {
                    position: absolute;
                    right: 0;
                    bottom: 0;
                    border: 5px solid transparent;
                    border-right-color: #e5e5e5;
                    border-bottom-color: #e5e5e5;
                }
            }
            .tabbar {
                padding:15px 25px 0;
                color: #fff;
                display: flex;
                align-items: center;
                justify-content: space-between;
                .tab-item {
                    font-size: 16px;
                    // width: 33.33%;
                    // text-align: center;
                    img {
                        width: 60px;
                        height: 30px;
                        vertical-align: middle;
                    }
                }
                .tab-line{
                    width: 1px;
                    height: 25px;
                    background-color: #e98184;
                }
            }
            .tabbar1 {
                padding-top:10px;
                padding:10px 30px 0;
            }
            .tab-1 {
  
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 50px;
                background-color:#fff;
                position: relative;
                // box-sizing: content-box;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        background-color: #fff;
                        border-radius: 25px;
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 35px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.content {
                    font-size: 15px;
                    line-height: 25px;
                    padding:0 15px;
                    line-height: 2;
                    text-align: justify;
                }
                .icon-list {
                    margin-top: 40px;
                    margin-bottom: 25px;
                    padding: 0 5px;
                    display: flex;
                    justify-content: space-between;
                    margin-bottom: 5px;
                    .icon-item {
                        display: flex;
                        flex-direction: column;
                        justify-content: space-between;
                        align-items: center;
                        font-size: 14px;
                        text-align: center;
                        width: 33.33%;
                        .icon {
                            width: 70px;
                            height: 70px;   
                            margin-bottom: 15px;
                        }
                        
                    }
                }
                .line {
                    display: flex;
                    align-items: center;
                    box-sizing: content-box;
                    margin: 30px 0 20px;
                    // margin: 0 10px;
                    .line-content {
                        overflow: hidden;
                        white-space: nowrap;
                        flex:1;
                        color: #e5e5e5;
                        // font-size: 100px;
                        font-weight: 500;
                        letter-spacing: 3px;
                    }
                    .line-left,.line-right {
                        width: 15px;
                        height: 15px;
                        background-color: #e5e5e5;
                        border-radius: 50%;
               
                    }
                    .line-left {
                        //  margin-right: 5px;
                        transform: translate(-50%)
                    }
                    .line-right {
                        // margin-left: 5px;
                        transform: translate(50%)
                    }
                    img {
                        width: 100%;
                    }

                }
                .shiyong {
                    padding: 0 15px;
                    img {
                        width: 100%;
                        padding-bottom: 25px;
                    }
                    .shiyong-title {
                        color: #df0b12;
                        font-size: 17px;
                        line-height: 17px;
                        font-weight: 600;
                    }
                    .shiyong-content {
                        margin: 15px 0;
                        font-size: 15px;
                        line-height: 2;
                        text-align: justify;
                    }

                }
            }
            .tab-2 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 50px;
                background-color:#fff;
                position: relative;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.content {
                    font-size: 15px;
                    line-height: 25px;
                    padding:0 15px;
                    line-height: 2;
                    text-align: justify;
                }
                .title-two {
                    margin-top: 40px;
                    font-size: 17px;
                    color: #e01117;
                    font-weight: bold;
                    text-align: center;
                }
                .content-two {
                    font-size: 15px;
                    line-height: 25px;
                    margin: 20px 10px;
                    background-color: #fff6f6;
                    box-shadow: inset 0px 1px 20px -7px #bf0000;
                    border-radius: 8px;
                    line-height: 2;
                    // border-top-right-radius: 8px;
                    .content-two-content {
                         padding: 20px;
                        text-align: justify;
                    }    
                    .content-two-list {
                         padding:20px;
                        .contnet-two-item {
                            display: flex;
                            align-items: center;
                            color: #df5156;                            
                            img {
                                width: 15px;
                                height: 15px;
                                margin-right: 2px;
                            }
                        }
                    }
                }
                .icon-list-photo {
                    width: 100%;
                    padding: 0 10px;
                    box-sizing: border-box;
                    margin:30px 0 50px;
                }
                //   .icon-list {
                //     margin-top: 25px;
                //     margin-bottom: 25px;
                //     padding: 0 5px;
                //     display: flex;
                //     justify-content: space-between;
                //     flex-wrap: wrap;
                //     .icon-item {
                //         width: 33.33%;
                //         display: flex;
                //         flex-direction: column;
                //         // justify-content: space-between;
                //         align-items: center;
                //         margin-bottom: 25px;
                //         font-size: 12px;
                //         color:#626262;
                //         text-align: center;
                //         .icon {
                //             width: 50px;
                //             height: 50px;
                //             margin-bottom: 15px;
                //         }
                //         .icon-title {
                //             color: #e01117;
                //             font-weight: bold;
                //             // font-size: 23px;
                //         }
                //         >view {
                //             margin-bottom: 5px;
                //         }
                        
                //     }
                // }

            }
            .tab-3 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 50px;
                padding-bottom: 10px;
                background-color:#fff;
                position: relative;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.content {
                    font-size: 15px;
                    line-height: 25px;
                    padding:0 15px;
                    line-height: 2;
                }
                .componet-level {
                    margin:0 10px 30px;
                }
          
            
            

            }
            .tab-4 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 50px;
                padding-bottom: 15px;
                background-color:#fff;
                position: relative;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.content {
                    font-size: 15px;
                    line-height: 25px;
                    padding:0 15px 20px;
                    line-height: 2;
                    text-align: justify;
                }
                .title-two {
                    margin: 20px 15px 0;
                    font-size: 17px;
                }
                .content-two {
                    font-size: 15px;
                    line-height: 25px;
                    margin: 20px 15px;
                    background-color: #fff6f6;
                    box-shadow: inset 0px 1px 20px -7px #bf0000;
                    border-radius: 8px;
                    text-align: justify;
                 
                    .content-two-list {
                         padding:20px 10px;
                        .contnet-two-item {
                            display: flex;
                            align-items: center;                            
                            color: #df5156;                            
                            img {
                                width: 15px;
                                height: 15px;
                                margin-right: 2px;
                            }
                        }
                    }
                }
                  .icon-list {
                    margin-top: 25px;
                    margin-bottom: 25px;
                    padding: 0 5px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    .icon-item {
                        display: flex;
                        flex-direction: column;
                        // justify-content: space-between;
                        align-items: center;
                        margin-bottom: 25px;
                        font-size: 14px;
                        color:#626262;
                        .icon {
                            width: 50px;
                            height: 50px;
                            margin-bottom: 15px;
                        }
                        .icon-title {
                            color: #e01117;
                            font-weight: bold;
                            // font-size: 23px;
                        }
                        >view {
                            margin-bottom: 5px;
                        }
                        
                    }
                }

            }
            .tab-5 {
                // width:100%;
                // height: 300px;
                margin: 80px 10px 0;
                border-radius: 8px;
                // border-top-left-radius: 8px;
                // border-top-right-radius: 8px;
                padding-top: 25px;
                background-color:#fff;
                position: relative;
                // box-sizing: content-box;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                        // background-color: #fff;
                        border-radius: 25px;
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 35px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.title-two {
                    font-size: 15px;
                    line-height: 25px;
                    font-weight: bold;
                    color: #df0b12;
                    padding:10px 0 15px;
                    text-align: center;
                }
                .icon-list {
                    // margin-top: 25px;
                    margin-bottom: 25px;
                    padding: 0 5px;
                    margin-bottom: 5px;
                    .icon-item {
                        display: flex;
                        align-items: center;
                        padding: 8px 0;
                        .icon {
                            width: 20px;
                            height: 20px;
                            border: 1px solid #a4a4a4;
                            border-radius: 50%;
                            text-align: center;
                            margin: 0 10px 0 20px;
                            color: #a4a4a4;
                        }
                        
                    }
                }
                .line {
                    display: flex;
                    align-items: center;
                    box-sizing: content-box;
                    .line-content {
                        overflow: hidden;
                        white-space: nowrap;
                        flex:1;
                        color: #e5e5e5;
                        // font-size: 100px;
                        font-weight: 500;
                        letter-spacing: 3px;
                    }
                    .line-left,.line-right {
                        width: 15px;
                        height: 15px;
                        background-color: #e5e5e5;
                        border-radius: 50%;
               
                    }
                    .line-left {
                        //  margin-right: 5px;
                        transform: translate(-50%)
                    }
                    .line-right {
                        // margin-left: 5px;
                        transform: translate(50%)
                    }
                    img {
                        width: 100%;
                    }

                }
                .shiyong {
                    padding: 15px;
                    .shiyong-content {
                        // margin: 15px 0;
                        font-size: 14px;
                        line-height: 2;
                        text-align:justify;
                    }

                }
            }
            .tab-6 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 50px;
                padding-bottom: 15px;
                background-color:#fff;
                position: relative;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                >.content {
                    // font-size: 15px;
                    line-height: 25px;
                    padding:0 15px 20px;
                    line-height: 2;
                    text-align:justify;
                }
                .title-two {
                    margin: 15px;
                    // font-size: 17px;
                    text-align:justify;
                }
                .content-two {
                    // font-size: 15px;
                    line-height: 25px;
                    margin: 20px 15px;
                    background-color: #fff6f6;
                    box-shadow: inset 0px 1px 20px -7px #bf0000;
                    border-radius: 8px;
                 
                    .content-two-list {
                         padding:20px 10px;
                        .contnet-two-item {
                            display: flex;
                            align-items: center;                            
                            color: #db4348;
                            .level-tag {
                                margin: 0 8px 0;
                            }
                        }
                    }
                }
           
            }
            .tab-7 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 80px;
                padding-bottom: 60px;
                background-color:#fff;
                position: relative;
                text-align: center;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                a {
                    color: #2992ff;
                    text-decoration: underline;
                    margin: 50px 0;
                }
            }
            .tab-8 {
                margin: 80px 10px 0;
                border-radius: 8px;
                padding-top: 70px;
                padding-bottom: 50px;
                background-color:#ffffff;
                position: relative;
                text-align: center;
                display: flex;
                flex-direction: column;
                justify-content: center;
                align-items: center;
                >.title {
                        position: absolute;
                        top: 0;
                        left: 50%;
                        transform: translate(-50%,-50%);
                    .title-mask {
                        margin-top: 2px;
                        color: #fff;
                        font-size: 20px;
                        font-weight: bold;
                        padding: 10px 25px;
                        background-color: #e01b22;
                        white-space: nowrap;
                        border-radius: 25px;
                    }
                }
                img {
                    width: 150px;
                }
                .web {
                    // color: #2992ff;
                    display:flex;
                    padding:  0 15px;
                    flex-wrap: wrap;
                    justify-content: center;
                    align-items: center;
                    font-size: 14px;
                    span {
                        font-size: 16px;
                    }
                }
                >span {
                        margin:15px 0;
                }
               
            }
            .bottom-container {
                padding: 20px;
                .cn,.en {
                    line-height: 2;
                }
                .cn {
                    margin: 40px 0;
                    text-align: justify;
                }
            }
        }
        
    }
}

</style>